<div class="p-grid">
  <div class="p-col-12">
    <div class="card">
      <h3 class="p-mb-0">{{'Configuration.Title' | transloco}}</h3>
    </div>
  </div>
  <div class="p-col-12 p-lg-2">
    <div class="card">
      <p-panelMenu class="configMenuPanel" [model]="configMenu" [style]="{'width':'100%'}">
        <ng-template pTemplate="submenuicon">
          <span class="expandIcon p-mr-2"></span>
        </ng-template>
      </p-panelMenu>
    </div>
  </div>
  <div class="p-col-12 p-lg-10">
    <div class="card">
        <div *ngIf="selectedWindow === 'company'">
          <app-company-branch></app-company-branch>
        </div>

        <div *ngIf="selectedWindow === 'mobile'">
          Mobile
        </div>

        <div *ngIf="selectedWindow === 'web'">
          Web
        </div>

        <div *ngIf="selectedWindow === 'notification'">
            <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'template'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'global'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'duplicate'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <!-- <div *ngIf="selectedWindow === 'saved'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div> -->

        <div *ngIf="selectedWindow === 'series'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>
        <div *ngIf="selectedWindow === 'activity'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'permission'">
          Permission
        </div>

        <div *ngIf="selectedWindow === 'privacy'">
          {{'Configuration.User.Privacy' | transloco}}
        </div>

        <div *ngIf="selectedWindow === 'user'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'role'">
            <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'roleHierarchy'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'profile'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'visibility'">
            <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'sample1'">
          Sample 1
        </div>

        <div *ngIf="selectedWindow === 'sample2'">
          Sample 2
        </div>

        <div *ngIf="selectedWindow === 'accountModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'activityModule'">
          <p-tabView>
            <p-tabPanel header="Category">
              <p>Activity Category</p>
            </p-tabPanel>
            <p-tabPanel header="Stages">
              <p>Activity Stages</p>
            </p-tabPanel>
          </p-tabView>
        </div>

        <div *ngIf="selectedWindow === 'casesModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'crmCustomModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'contactsModule'">
            <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'goalsModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'leadModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'opportunityModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'Questionnaire'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'cSettingModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'territoryManagement'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'fSettingModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>
        <div *ngIf="selectedWindow === 'workspaceModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'financeSetupModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'productModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'pricebookModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'locationModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'setupModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'quantityModule'">
            <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'iSettingModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'ordersModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'purchaseModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'customersModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'customModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'customRuleModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'accountingModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'botsModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'calendarModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'emailModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'leadGenerationModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'posModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'proposalModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'ecommerceModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'smtpModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

        <div *ngIf="selectedWindow === 'shipModule'">
          <ng-container *ngComponentOutlet="componentName"></ng-container>
        </div>

    </div>
  </div>

  <p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
  <p-confirmDialog key="delete-custom-field" [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
